import React from 'react';
import styled from '@emotion/styled';
import { Settings } from 'react-feather';

type Props = {
  children: any;
  toggleSettings: any;
  status: 'success' | 'warning' | 'danger';
};

function Header({ children, toggleSettings, status = 'warning' }: Props) {
  return (
    <Container>
      <Status status={status} />
      <Title>{children}</Title>
      <SettingsButton onClick={toggleSettings}>
        <Settings size={24} color="#fff" />
      </SettingsButton>
    </Container>
  );
}

export default Header;

const Title = styled('span')`
  flex: 1 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const SettingsButton = styled('span')`
  margin: auto 16px;
  display: flex;
  align-items: center;
  opacity: 0.64;
`;

const Status = styled('div')<{ status: Props['status'] }>`
  flex: 0 56px;
  width: 56px;
  height: 64px;
  display: flex;
  align-items: center;

  &:after {
    content: '';
    width: 16px;
    height: 16px;
    border-radius: 16px;
    margin: auto;
    background: ${({ status }) =>
      ({
        success: '#2c9918',
        warning: '#ffc107',
        danger: '#e80e0c',
      }[status])};
  }
`;

const Container = styled('div')`
  text-align: center;
  font-weight: bold;
  color: #fff;
  height: 64px;
  display: flex;
  align-items: center;
  margin-bottom: -8px;
  width: 100%;
`;
